var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"app-header",class:_vm.appHeaderClass},[_c('div',{staticClass:"app-header-wrap container"},[_c('span',{staticClass:"app-header__logo"},[_c('logo-icon')],1),_vm._v(" "),_c('ui-button',{staticClass:"app-header__button",attrs:{"theme":"blue"},on:{"click":_vm.handleButtonClick}},[_vm._v("\n      Contact "),_c('span',[_vm._v("Us")])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d860ab7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/AppHeader.vue
// module id = null
// module chunks = 